import { Environment } from '@/enums/environment';

const APP_TITLE: string = 'GLS Partner Portal';

const setAppTitle = (environment: Environment): void => {
    document.title = environment === Environment.PROD ? APP_TITLE : `${APP_TITLE} (${environment})`;
};

export { setAppTitle };
